/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminInviteUserOptions, AdminInviteUserResponses } from '../../models/AdminInviteUser'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Invite a user to the org.
 * @summary Invite User
 * {@link /admin/org/:org_id/invite}
 */
export function adminInviteUser<ThrowOnError extends boolean = true>(options: Options<AdminInviteUserOptions, ThrowOnError>): Promise<UnwrappedResult<AdminInviteUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/org/{org_id}/invite', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminInviteUserResponses, ThrowOnError>>
}
